module.exports = __webpack_public_path__ + "img/policy.95628e01.png";